// extracted by mini-css-extract-plugin
export default {"dark-background":"Button_dark-background__6UoaX","player-overlay":"Button_player-overlay__UCIp2","button":"Button_button__JBBzO"};